import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import { publishEditoEventPath } from 'app/routes/edito';
import type { IEditoEventListResponse } from 'app/typings/edito';
import { apiMutation } from 'app/utils/request/api';

type PayloadProps = {
  id: string;
};

export const usePublishEditoEvents = () => {
  return useMutation<IEditoEventListResponse[], unknown, PayloadProps, unknown>(
    {
      mutationFn: async (payload: PayloadProps) =>
        apiMutation(
          'PATCH',
          {
            path: publishEditoEventPath,
            params: { id: payload.id },
          },
          payload
        ),
      onSuccess: () => {
        message.success('The event has been successfully published');
      },
      onError: () => {
        message.error('Error while publishing the event');
      },
    }
  );
};
